const data = {
	"width": 512,
	"height": 512,
	"body": "<mask id=\"circleFlagsHu0\"><circle cx=\"256\" cy=\"256\" r=\"256\" fill=\"#fff\"/></mask><g mask=\"url(#circleFlagsHu0)\"><path fill=\"#eee\" d=\"m0 167l253.8-19.3L512 167v178l-254.9 32.3L0 345z\"/><path fill=\"#d80027\" d=\"M0 0h512v167H0z\"/><path fill=\"#6da544\" d=\"M0 345h512v167H0z\"/></g>"
};
exports.__esModule = true;
exports.default = data;
